import axios from 'axios'

export default {
    createRoom(name, level, category, participants, is_public) {
        return axios.post('/games/knockout/rooms', {
            name: name,
            level: level,
            category: category,
            participants: participants,
            is_public: is_public,
        })
    },

    findGame(code) {
        return axios.get('/games/knockout/room/find', {
            params: {
                code: code
            }
        })
    }
}
